const activityType = {
	OPEN_ENDED_QUESTION: 1,
	POLL_QUESTION: 2,
	MULTIPLE_CHOICE_QUESTION: 3,
}

const totalByActivity = (activities, activityType) =>
	activities.filter(activity => activity.activityType === activityType).length

const activitiesCounter = media => {
	const totalActivities = {
		byActivity: {},
		total: 0,
	}
	const keys = Object.keys(activityType)
	for (const n in keys) {
		totalActivities.byActivity[keys[n]] = 0
	}
	if (!media.breakpoints) {
		return totalActivities
	}
	media.breakpoints.forEach(breakpoint => {
		for (const activity in activityType) {
			const sum = totalByActivity(breakpoint.activities, activityType[activity])
			totalActivities.byActivity[activity] += sum
			totalActivities.total += sum
		}
	})
	return totalActivities
}

export default activitiesCounter
